import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachSendEntity } from './outreach-send.entity';

@Entity('_outreach_template')
export class OutreachTemplateEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('enum', { name: '_campaign_type', enum: ['email', 'phone'] })
	public campaignType!: 'email' | 'phone';

	@Column('varchar', { name: '_subject', nullable: true, length: 255 })
	public subject!: string | null;

	@Column('longtext', { name: '_html_content', nullable: true })
	public htmlContent!: string | null;

	@Column('text', { name: '_text_content', nullable: true })
	public textContent!: string | null;

	@Column('text', { name: '_phone_script', nullable: true })
	public phoneScript!: string | null;

	@Column('enum', {
		name: '_template_type',
		enum: ['campaign', 'automation', 'transactional'],
	})
	public templateType!: 'campaign' | 'automation' | 'transactional';

	@Column('tinyint', { name: '_is_system_template', default: () => "'0'" })
	public isSystemTemplate!: number;

	@Column('varchar', { name: '_preview_text', nullable: true, length: 255 })
	public previewText!: string | null;

	@Column('json', { name: '_variables', nullable: true })
	public variables!: object | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@OneToMany(
		() => OutreachSendEntity,
		(outreachSend) => outreachSend.fkOutreachTemplate,
		{},
	)
	public outreachSends!: Array<OutreachSendEntity>;
}
